import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client.js';
import StoryCard from '../components/StoryCard.jsx';
import { SparkleIcon } from '../components/icons.jsx';

export default function HomePage() {
  const [stories, setStories] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.stories
      .list({ page: 1, pageSize: 24 })
      .then(setStories)
      .catch((e) => setError(e.message));
  }, []);

  return (
    <div className="mx-auto max-w-5xl px-4 py-10">
      <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="text-4xl font-bold text-brand-700">Galeria de cuentos</h1>
          <p className="mt-1 text-gray-600">
            Cuentos infantiles ilustrados generados con IA. Crea el tuyo y compartelo con tu familia.
          </p>
        </div>
        <Link
          to="/create"
          className="inline-flex items-center gap-2 rounded-full bg-brand-600 px-5 py-2.5 font-semibold text-white shadow hover:bg-brand-700"
        >
          <SparkleIcon size="1.1em" /> Crear un cuento
        </Link>
      </div>

      {error && (
        <div className="mt-8 rounded-lg border border-red-200 bg-red-50 p-4 text-red-700">{error}</div>
      )}

      {!error && stories && stories.items.length === 0 && (
        <div className="mt-12 rounded-2xl border-2 border-dashed border-brand-200 bg-white p-10 text-center">
          <p className="text-lg text-gray-600">Todavia no hay cuentos publicados.</p>
          <Link
            to="/create"
            className="mt-4 inline-flex items-center gap-2 rounded-full bg-brand-600 px-6 py-2.5 font-semibold text-white shadow hover:bg-brand-700"
          >
            <SparkleIcon size="1.1em" /> Crear el primero
          </Link>
        </div>
      )}

      {!error && stories && stories.items.length > 0 && (
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {stories.items.map((s) => (
            <StoryCard key={s.id} story={s} />
          ))}
        </div>
      )}

      {!error && !stories && (
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="overflow-hidden rounded-2xl border border-brand-100 bg-white shadow-sm">
              <div className="aspect-square w-full animate-pulse bg-brand-50" />
              <div className="space-y-2 p-4">
                <div className="h-4 w-3/4 animate-pulse rounded bg-brand-50" />
                <div className="h-3 w-1/3 animate-pulse rounded bg-brand-50" />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
